var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInformationColor = function SvgInformationColor(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 16,
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#369AFE",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 13.12c-.265 0-.52-.078-.707-.216-.188-.138-.293-.326-.293-.521V6.857c0-.195.105-.383.293-.52.187-.14.442-.217.707-.217s.52.078.707.216c.188.138.293.326.293.521v5.526c0 .195-.105.383-.293.521A1.2 1.2 0 0 1 8 13.12M8 5.12a1.2 1.2 0 0 1-.707-.22C7.105 4.76 7 4.57 7 4.37v-.62c0-.199.105-.39.293-.53C7.48 3.079 7.735 3 8 3s.52.079.707.22c.188.14.293.331.293.53v.62c0 .199-.105.39-.293.53A1.2 1.2 0 0 1 8 5.12"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInformationColor);
export default ForwardRef;